export type PrizmTextMaskCorrectionHandler = (char: string, index: number) => string | null;
